import { pluralRu } from './format';

export type NicheHint = { tier: 'niche' | 'direction' | 'daily'; count: number };

type T = (key: string, params?: Record<string, string | number>) => string;

/**
 * The value-line under the price, pluralised.
 *
 * Russian agrees the noun (and the verb «появляется/появляются») with the
 * count: «2 новых лота», «5 новых лотов», «1 новый лот». Baking a fixed noun
 * into the i18n string printed the 5+ form for every count — «4 новых лотов».
 * The `{{lots}}`/`{{appears}}` placeholders are filled here via `pluralRu`; the
 * Uzbek templates ignore them (Uzbek is invariant — «lot» never changes).
 */
export function nicheHintLine(hint: NicheHint, t: T): string {
  const n = hint.count;
  if (hint.tier === 'niche') {
    return t('billing.card.nicheOpen', {
      count: n,
      lots: pluralRu(n, 'открытый лот', 'открытых лота', 'открытых лотов'),
    });
  }
  const appears = pluralRu(n, 'появляется', 'появляются', 'появляется');
  const lots = pluralRu(n, 'новый лот', 'новых лота', 'новых лотов');
  return hint.tier === 'direction'
    ? t('billing.card.nicheDirection', { count: n, lots, appears })
    : t('billing.card.nicheDaily', { count: n, lots, appears });
}
